/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface GcpArtifactRepositoryImageResponse { 
    /**
     * URI of a Image.
     */
    uri?: string;
    /**
     * Name/Key of a Image.
     */
    image_name?: string;
    /**
     * Size of the image in bytes
     */
    image_size_bytes?: number;
    tags?: Array<string>;
    /**
     * Creation timestamp
     */
    create_time?: Date;
    /**
     * Update timestamp
     */
    update_time?: Date;
    /**
     * Image upload timestamp
     */
    upload_time?: Date;
}

